import { render, staticRenderFns } from "./LinkField.vue?vue&type=template&id=27467714&scoped=true"
import script from "./LinkField.vue?vue&type=script&lang=js"
export * from "./LinkField.vue?vue&type=script&lang=js"
import style0 from "./LinkField.vue?vue&type=style&index=0&id=27467714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27467714",
  null
  
)

export default component.exports